import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPostcard2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconPostcard2"><Path fillRule="evenodd" clipRule="evenodd" d="M2 20V4H22V20H2ZM6 9V11H10V9H6ZM12 9V15H18V9H12ZM6 13V15H10V13H6Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPostcard2;
